import { debounce } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import contractApi from '../../APIs/contract';
// import { ReactComponent as PlusIcon } from '../../assets/icons/plus.svg';
import {
  Button,
  PageHeader,
  Pagination,
  Typography,
} from '../../designComponents';
import Table, { TableDataType } from '../../designComponents/Table';
import { CONTRACT_DETAIL_ROUTE_CLIENT } from '../../routes/routePaths';
import Store from '../../store';
import { RootState } from '../../store/selectors';
import theme from '../../theme';
import { PaginationType } from '../../types';
import { humanReadableDate, requestAPI } from '../../utils';
import { MyParamsType } from '../Building';
import { ContractContainerStyled } from './style';

const ClientContract = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const dispatch = useDispatch();

  const pagination = useSelector(
    (state: RootState) => state.contracts.pagination
  );

  const contracts = useSelector((state: RootState) => state.contracts.data);
  const handleContracts = async (myParams: MyParamsType) => {
    try {
      await requestAPI(
        contractApi.getAllContract({
          page: myParams.page,
          limit: myParams.limit,
          search: myParams.search ? myParams.search : '',
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

  const debouncedFunction = useCallback(
    debounce((myParams) => handleContracts(myParams), 500),
    []
  );

  useEffect(() => {
    handleContracts(pagination);
  }, []);

  const tableData: TableDataType = {
    headings: [
      { key: 'date', label: 'Date' },
      { key: 'title', label: 'Job Title' },
      {
        key: 'clientName',
        label: 'Client Name',
      },
      {
        key: 'name',
        label: 'Building Name',
      },
      { key: 'address', label: 'Address of Property' },

      {
        key: 'actions',
        label: 'Action',
      },
    ],
    body: Array.isArray(contracts)
      ? contracts?.map((contract) => {
          return {
            id: contract?.id,
            date: humanReadableDate(contract?.createdAt),
            title: contract?.job?.jobTitle,
            clientName: contract?.technician?.fullName,
            name: contract?.job?.building[0]?.buildingName,
            address: contract?.job?.building[0]?.buildingAddress,
            actions: (
              <Button
                variant="secondary"
                onClick={() =>
                  navigate(
                    CONTRACT_DETAIL_ROUTE_CLIENT.replace(
                      ':clientContractId',
                      contract._id
                    )
                  )
                }
                style={{
                  backgroundColor: theme.colors.blueLight,
                  border: `1px solid ${theme.colors.blueLight}`,
                }}
              >
                View Details
              </Button>
            ),
          };
        })
      : [],
  };

  const handlePagination = (updatedParams: PaginationType) => {
    handleContracts(updatedParams);
    dispatch(Store.Actions.update('contracts.pagination', updatedParams));
  };

  const handleOnSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearch(value);
    debouncedFunction({ ...pagination, page: 1, search: value });
  };

  return (
    <ContractContainerStyled>
      <PageHeader
        pageTitle={<Typography variant="title">Contract</Typography>}
        // otherActions={
        //     <Button variant="secondary" size="sm" onClick={() => {}}>
        //       <PlusIcon className="icon" />
        //       Create Contract
        //     </Button>
        // }
        handleOnSearchTextChange={handleOnSearchTextChange}
        search={search}
      />

      <div className="table-container">
        <Table tableData={tableData} maxWidthForCardView="800px" />
      </div>

      <Pagination
        activePage={pagination.page}
        handlePagination={handlePagination}
        limit={pagination.limit}
        totalCount={pagination.totalData || 0}
      />
    </ContractContainerStyled>
  );
};

export default ClientContract;
